// Filter Toggle Functionality (using event delegation to survive AJAX updates)
theme.filterToggle = (function () {
  let initialized = false;

  function initFilterToggle() {
    const facetsVertical = document.querySelector('.facets-vertical');
    if (!facetsVertical) return;

    // Restore state from localStorage
    const isHidden = localStorage.getItem('filterSidebarHidden') === 'true';
    if (isHidden) {
      facetsVertical.classList.add('filters-hidden');
      const filterToggleBtn = document.querySelector('[data-filter-toggle]');
      if (filterToggleBtn) {
        filterToggleBtn.setAttribute('aria-expanded', 'false');
      }
    }

    // Only bind event delegation once
    if (initialized) return;
    initialized = true;

    // Use event delegation on document to handle clicks on dynamically updated elements
    document.addEventListener('click', function(event) {
      const facetsContainer = document.querySelector('.facets-vertical');
      if (!facetsContainer) return;

      // Handle hide filters button (desktop-facets__heading)
      const filterToggleBtn = event.target.closest('[data-filter-toggle]');
      if (filterToggleBtn) {
        event.preventDefault();
        facetsContainer.classList.add('filters-hidden');
        filterToggleBtn.setAttribute('aria-expanded', 'false');
        localStorage.setItem('filterSidebarHidden', 'true');
        return;
      }

      // Handle show filters button (toolbar button)
      const filterShowBtn = event.target.closest('[data-filter-show]');
      if (filterShowBtn) {
        event.preventDefault();
        facetsContainer.classList.remove('filters-hidden');
        const toggleBtn = document.querySelector('[data-filter-toggle]');
        if (toggleBtn) {
          toggleBtn.setAttribute('aria-expanded', 'true');
        }
        localStorage.setItem('filterSidebarHidden', 'false');
        return;
      }
    });
  }
  return initFilterToggle;
})();

// Initialize filter toggle on DOMContentLoaded
document.addEventListener('DOMContentLoaded', function() {
  theme.filterToggle();
});

// Re-initialize on Shopify section load (for Theme Editor)
document.addEventListener('shopify:section:load', function() {
  theme.filterToggle();
});

// Product Grid Column
theme.collectionProduct = (function () {
  function productGrid(e) {

    // Proudct Column
    const productColBtnWrapper = document.querySelector(
      ".product__grid_column_buttons"
    );
    if(productColBtnWrapper){
        const gridColumnButtons = productColBtnWrapper.querySelectorAll(".gird__column_icon");
        const girColumnWrapper = document.querySelector("#ProductGridContainer");
        const girColumnWrapperClssList = girColumnWrapper.classList;

        let gridClassName = localStorage.getItem("gridColumn");
        if (gridClassName) {
          girColumnWrapper.classList.remove(
            "grid-col-2",
            "grid-col-3",
            "grid-col-4"
          );
          girColumnWrapper.classList.add(gridClassName);
        }

        gridColumnButtons.forEach((singleItem) => {
          if (gridClassName) {
            switch (gridClassName) {
              case "grid-col-2":
                if (singleItem.classList.contains("product_col_two")) {
                  singleItem.classList.add("active");
                  getSiblings(singleItem).forEach(function (item) {
                    item.classList.remove("active");
                  });
                }
                break;
              case "grid-col-3":
                if (singleItem.classList.contains("product_col_three")) {
                  singleItem.classList.add("active");
                  getSiblings(singleItem).forEach(function (item) {
                    item.classList.remove("active");
                  });
                }
                break;
              default:
                if (singleItem.classList.contains("product_col_four")) {
                  singleItem.classList.add("active");
                  getSiblings(singleItem).forEach(function (item) {
                    item.classList.remove("active");
                  });
                }
            }
          }

          singleItem.addEventListener("click", (event) => {
            singleItem.classList.add("active");
            getSiblings(singleItem).forEach(function (item) {
              item.classList.remove("active");
            });

            if (singleItem.classList.contains("product_col_two")) {
              localStorage.setItem("gridColumn", "grid-col-2");

              gridClassName = localStorage.getItem("gridColumn");
              girColumnWrapper.classList.add(gridClassName);

              if (
                girColumnWrapperClssList.contains("grid-col-5") ||
                girColumnWrapperClssList.contains("grid-col-4") ||
                girColumnWrapperClssList.contains("grid-col-3") ||
                girColumnWrapperClssList.contains("grid-col-1")
              ) {
                girColumnWrapper.classList.remove(
                  "grid-col-5",
                  "grid-col-4",
                  "grid-col-3",
                  "grid-col-1"
                );
              }
            } else if (singleItem.classList.contains("product_col_three")) {
              localStorage.setItem("gridColumn", "grid-col-3");
              gridClassName = localStorage.getItem("gridColumn");

              girColumnWrapper.classList.add(gridClassName);
              if (
                girColumnWrapperClssList.contains("grid-col-5") ||
                girColumnWrapperClssList.contains("grid-col-4") ||
                girColumnWrapperClssList.contains("grid-col-2") ||
                girColumnWrapperClssList.contains("grid-col-1")
              ) {
                girColumnWrapper.classList.remove(
                  "grid-col-5",
                  "grid-col-4",
                  "grid-col-2",
                  "grid-col-1"
                );
              }
            } else if (singleItem.classList.contains("product_col_four")) {
              localStorage.setItem("gridColumn", "grid-col-4");
              gridClassName = localStorage.getItem("gridColumn");
              girColumnWrapper.classList.add(gridClassName);
              if (
                girColumnWrapperClssList.contains("grid-col-5") ||
                girColumnWrapperClssList.contains("grid-col-3") ||
                girColumnWrapperClssList.contains("grid-col-2") ||
                girColumnWrapperClssList.contains("grid-col-1")
              ) {
                girColumnWrapper.classList.remove(
                  "grid-col-5",
                  "grid-col-3",
                  "grid-col-2",
                  "grid-col-1"
                );
              }
            }
          });
        });
    }

  }
  return productGrid;
})();
